@import '@hevoio/hevo-ui-toolkit/styles/variables';

@import 'variables';

.editorWrapper {
  border: solid $border-width $divider-color;
  border-radius: $border-radius-md;
  overflow: hidden;
  height: $workbench-query-editor-default-height;
  display: flex;
  flex-direction: row;
}

.gutter {
  width: 29px;
  background-color: $secondary-bg;
  border-right: solid $border-width $divider-color;
  flex-shrink: 0;
}

.code {
  padding: $spacer *.5 $spacer * .75;
}
